import styled from "styled-components";
import TippyRaw from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

export const Container = styled.div`
  max-width: 1024px;
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  height: 182px;
  padding: 48px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.md} {
    padding: 32px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
    height: fit-content;
    padding: 12px 24px;
  }
`;

export const ConstellationInfoContainer = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    padding: 12px 0px;
  }
`;

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.md} {
    align-items: center;
  }

  label {
    color: rgba(255, 255, 255, 0.96);
    text-align: center;
    font-size: 48px; /* fallback */
    font-size: clamp(32px, 4.57vw + 1.18px, 48px);
    font-style: normal;
    font-weight: 500;
    line-height: 1.16;
    letter-spacing: -0.96px;
    
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.md} {
      font-size: 32px;
      line-height: 1.25
      letter-spacing: -0.64px;
    }
  }
`;

export const MessageDescriptionContainer = styled.div`
  display: flex;
  align-items: center;
  span {
    color: #B6B9C8;
    color: #979AA8;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.875;
    
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.md} {
      font-size: 16px;
    }
  }

  svg {
    width: 15px;
    height: 15px;
    margin-left: 5px;
    margin-top: 7px;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.md} {
      display: none;
    }
  }
`;

export const Tippy = styled(TippyRaw)`
  width: 320px;
  background: #292d3a !important;
  padding: 18px 20px;
  font-size: 12px !important;

  .tippy-arrow {
    color: #292d3a;
  }
`;
